import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Scenery | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <div className="ch-lang-en">
            <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>简体中文</Link>
          </div>
          <div className="space-50"></div>
          <h2>Attractions in Jeju Island</h2>
          <p align="justify">
            <b>
            Jeju Island, South Korea&apos;s largest volcanic island, is a destination where pristine volcanic landscapes meet coastal leisure charm. As a renowned UNESCO World Natural Heritage resort, it is Korea&apos;s iconic hub for island tourism, wellness, and film locations. Jeju is famed for its unique volcanic geology, authentic island folk culture, and the striking blend of mountain and coastal scenery—from towering dormant volcanoes and deep lava caves to crystal-clear blue seas and black rocky shores.
            <br></br>
            Jeju is home to several world-famous natural treasures, including Mount Hallasan, the island&apos;s highest peak with the volcanic lake Baengnokdam, and Seongsan Ilchulbong Peak, a UNESCO World Heritage Site formed by submarine volcanic eruptions, offering panoramic views where mountains meet the sea. Another must-visit destination is Manjanggul Cave, a lava tube that preserves geological wonders from volcanic activity over a million years ago, revealing a one-of-a-kind volcanic realm.
            <br></br>
            Jeju&apos;s culinary scene is a paradise for food lovers, featuring authentic island specialties such as Jeju black pork, fresh abalone, and sweet citrus. Whether hiking along coastal Olle trails, visiting Seong-eup Folk Village, or exploring the shops of Seogwipo, Jeju offers every visitor a relaxing, memorable island experience.
            </b>
          </p>

          <li>
            <a href="#Mount Hallasan">Mount Hallasan</a>
          </li>
          <li>
            <a href="#Seongsan Ilchulbong">Seongsan Ilchulbong Peak</a>
          </li>
          <li>
            <a href="#Udo Island">Udo Island</a>
          </li>
          <li>
            <a href="#Manjanggul Cave">Manjanggul Cave</a>
          </li>
          <li>
            <a href="#Seopjikoji">Seopjikoji</a>
          </li>
          <li>
            <a href="#Yongduam Rock">Yongduam Rock</a>
          </li>
          <li>
            <a href="#Daepo Jusangjeolli Cliff">Jusangjeolli Cliff</a>
          </li>
          <li>
            <a href="#Kimchi">Kimchi</a>
          </li>
          <li>
            <a href="#Samgyetang">Samgyetang</a>
          </li>
          <li>
            <a href="#Korean BBQ">Korean BBQ</a>
          </li>
          <li>
            <a href="#Bibimbap">Bibimbap</a>
          </li>

          <br />

          <hr></hr>
          <h4 id="Mount Hallasan">Mount Hallasan</h4>
          <p align="justify">
            Mount Hallasan is the highest peak on Jeju Island at 1,950 meters, the tallest mountain in South Korea and a dormant volcano. At its summit lies the mysterious Baengnokdam crater lake, with scenery that changes through the seasons—cherry blossoms in spring, lush greenery in summer, fiery foliage in autumn, and snow-covered slopes in winter. Listed as a UNESCO World Natural Heritage Site, Hallasan is Jeju&apos;s most iconic natural landmark, and hiking its trails rewards visitors with sweeping views across the entire volcanic island.
          </p>
          <p>
            <img
              src="./images/scenery/hannashan-opt.jpg"
              alt="Mount Hallasan"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Seongsan Ilchulbong">Seongsan Ilchulbong Peak</h4>
          <p align="justify">
            Seongsan Ilchulbong Peak sits at the eastern tip of Jeju Island. This 182-meter-tall tuff cone was formed by submarine volcanic eruptions and is named for the spectacular sunrises viewed from its summit. Its distinctive bowl-shaped crater set against blue seas and skies earned it UNESCO World Heritage status. On festive occasions, traditional haenyeo (sea women) performances are held here, making it an essential stop to experience Jeju&apos;s natural beauty and cultural heritage.
          </p>
          <p>
            <img
              src="./images/scenery/richufeng-opt.jpg"
              alt="Seongsan Ilchulbong Peak"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Udo Island">Udo Island</h4>
          <p align="justify">
            Udo Island is a small islet off the eastern coast of Jeju, named for its silhouette resembling a lying cow. Known as a &quot;treasure trove of coral&quot; and the &quot;home of haenyeo,&quot; the island features crystal-clear beaches, peanut ice cream, seafood noodles, and scenic spots such as Coral Beach and Seobinbaeksa White Sand Beach. A ferry ride away, visitors can explore by bicycle or island bus and enjoy a leisurely, slow-paced island getaway.
          </p>
          <p>
            <img
              src="./images/scenery/niudao-opt.jpg"
              alt="Udo Island"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Manjanggul Cave">Manjanggul Cave</h4>
          <p align="justify">
            Manjanggul Cave is one of Jeju&apos;s most spectacular and scientifically valuable lava tubes, stretching approximately 13.4 kilometers in total length, with a section open to the public. Inside, visitors can see lava stalactites, lava columns, and lava shelves formed by volcanic flows over a million years ago—a key component of Jeju&apos;s World Natural Heritage. With a constant temperature of about 11 to 21 degrees Celsius, the cave feels like a journey back to the age of ancient volcanic activity.
          </p>
          <p>
            <img
              src="./images/scenery/wanzhangku-opt.jpg"
              alt="Manjanggul Cave"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Seopjikoji">Seopjikoji</h4>
          <p align="justify">
            Seopjikoji is a coastal headland at the southeastern tip of Jeju, famous for its winding seaside walking paths, lighthouse, and golden canola flower fields in spring. A filming location for many Korean dramas, this peninsula extending into the sea offers views of Seongsan Ilchulbong Peak and the deep blue ocean—a paradise for photographers and an ideal spot to experience Jeju&apos;s romantic coastal scenery.
          </p>
          <p>
            <img
              src="./images/scenery/shedikezhi-opt.jpg"
              alt="Seopjikoji"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Yongduam Rock">Yongduam Rock</h4>
          <p align="justify">
            Yongduam Rock stands on the Seogwipo city waterfront, a lava formation shaped by wind and waves into a dragon&apos;s head about 10 meters high, its mouth facing the sea. Legend holds it possesses spiritual power and protects the island. Yongduam Park surrounds the rock, where visitors can watch waves crash against the stone up close, and it is a popular spot for sunset views along Jeju&apos;s western coast.
          </p>
          <p>
            <img
              src="./images/scenery/longtouyan-opt.jpg"
              alt="Yongduam Rock"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Daepo Jusangjeolli Cliff">Jusangjeolli Cliff</h4>
          <p align="justify">
            The Daepo Jusangjeolli Cliff in Seogwipo is a striking formation of hexagonal basalt columns created when lava from 250,000 to 140,000 years ago cooled rapidly upon contact with seawater and fractured naturally. Giant stone pillars line the coast like a grand colonnade. It is a must-visit site for understanding volcanic geology and photographing seascapes, showcasing Jeju&apos;s distinctive volcanic coastal landscape.
          </p>
          <p>
            <img
              src="./images/scenery/zhuzhuangjielidai-opt.jpg"
              alt="Jusangjeolli Cliff"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Kimchi">Kimchi</h4>
          <p align="justify">
            Kimchi is the most representative traditional fermented food of the Korean Peninsula, made from vegetables such as napa cabbage and radish seasoned with chili powder, garlic, and fish sauce, then fermented to a tangy, probiotic-rich delicacy. On Jeju, you can taste regional varieties featuring local citrus and seafood—an indispensable companion to every Korean meal, and recognized by UNESCO as Intangible Cultural Heritage of Humanity.
          </p>
          <p>
            <img
              src="./images/scenery/hanguopaocai-opt.jpg"
              alt="Kimchi"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Samgyetang">Samgyetang</h4>
          <p align="justify">
            Samgyetang is a traditional Korean nourishing dish—a whole young chicken stuffed with ginseng, glutinous rice, jujubes, and garlic, slow-simmered into a clear, flavorful, nutrient-rich broth. Typically served one chicken per bowl, eaten together with the soup, it follows the Korean belief of &quot;fighting heat with heat.&quot; A steaming bowl of samgyetang on Jeju warms you from the inside out and is a perfect introduction to Korean wellness cuisine.
          </p>
          <p>
            <img
              src="./images/scenery/hanguocanjitaang-opt.jpg"
              alt="Samgyetang"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Korean BBQ">Korean BBQ</h4>
          <p align="justify">
            Korean BBQ is one of the hallmarks of Korean dining culture, and Jeju is especially famous for black pork barbecue—Jeju black pork is firm in texture with evenly marbled fat and a distinctive flavor. Diners gather around charcoal or iron grills to cook their own meat, wrapping slices in lettuce with ssamjang (dipping sauce), garlic, and banchan side dishes—a hands-on, convivial way to experience Korea&apos;s bold food culture.
          </p>
          <p>
            <img
              src="./images/scenery/hanshikaorou-opt.jpg"
              alt="Korean BBQ"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Bibimbap">Bibimbap</h4>
          <p align="justify">
            Bibimbap combines rice, assorted vegetables, beef, egg, and gochujang (Korean chili paste) in a sizzling stone pot, where the bottom layer of rice crisps into a savory crust. Mixed together, it delivers rich textures and vibrant colors. Authentic versions can be found in restaurants and folk villages across Jeju—a steaming bowl that embodies the Korean philosophy of &quot;five colors, five flavors&quot; in a simple yet unforgettable dish.
          </p>
          <p>
            <img
              src="./images/scenery/shiguobanfan-opt.jpg"
              alt="Bibimbap"
              width="100%"
            />
          </p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
  }
  else {
    return (
      <React.Fragment>
      <SEO title="Scenery | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Scenery;
